import { render } from "./LieferantDetails.vue?vue&type=template&id=18506b18&scoped=true&ts=true"
import script from "./LieferantDetails.vue?vue&type=script&lang=ts"
export * from "./LieferantDetails.vue?vue&type=script&lang=ts"

import "./LieferantDetails.vue?vue&type=style&index=0&id=18506b18&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18506b18"]])

export default __exports__